<template>
  <div class="reviews">
    <div class="heading">
      <h2 class="center latest-buzz-title bottom-spacer ctf-heading ctf-restrict">What people are saying</h2>
    </div>
    <div class="review-grid">
      <div v-for="(review, index) in reviews" :key="index" class="review-block">
        <Product :product="review.product" :show-title="false" class="exp-review-container">
          <template v-slot:detail>
            <div class="review-content">
              <div class="review-rating accent">
                <i v-for="rating in review.rating" :key="rating" class="af af-star"></i>
              </div>
              <div class="review-title">
                {{ review.name }} from {{ review.location }} bought a <a :href="review.product.url">{{ review.product.title }}</a>
              </div>
              <div class="review-snippet">
                <ReadMore :text="quote(review.comment)"/>
              </div>
            </div>
          </template>
        </Product>
      </div>
    </div>
    <div class="more-reviews">
      <a href="/reviews" class="accent ctf-body">Read more reviews</a>
    </div>
  </div>
</template>

<script>
import Product from '@/components/commons/Product.vue';
import useHome from '@/compositions/useHome';
import ReadMore from '@/components/reviews/ReadMore.vue';

export default {
  name: 'Reviews',
  components: {
    Product,
    ReadMore
  },
  async setup() {
    const {
      reviews,
      fetchData
    } = useHome();

    if(!reviews?.length){
      await fetchData();
    }

    const quote = (text)=>{
      return `“${text}”`;
    }

    return {
      reviews,
      quote
    }
  }
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.reviews {
  margin: var(--space-10) 0px;

  .heading {
    width: 100%;
  }

  .latest-buzz-title {
    font-size: var(--font-size-24);
    font-family: var(--font-light);
  }

  .review-grid {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    @media (max-width: calc($mobile-breakpoint - 1px)) {
      flex-direction: column;
      flex-wrap: nowrap;
    }

    .review-block {
      margin-right: 8px;

      @media (max-width: calc($mobile-breakpoint - 1px)) {
        flex: 1 0 auto;
      }
      @media (min-width: $mobile-breakpoint) {
        flex: 1 0 45%;
      }
      @media (min-width: $tablet-breakpoint) {
        flex: 1 0 0;
      }

      .review-image {
        a {
          display: inline-block;
        }
      }

      .product-link {
        @media (max-width: $mobile-breakpoint) {
          width: 224px;
          margin-left: auto;
          margin-right: auto;
        }
      }
      .exp-review-container {
        @media (min-width: $mobile-breakpoint) {
          margin: 0px var(--space-10) var(--space-6);
        }
      }
    }

    .review-snippet {
      margin-top: var(--space-3);
    }
  }

  .review-content {
    width: 100%;
  }

  .more-reviews {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: var(--space-2);
  }
}
</style>
